import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptsService {
  constructor(@Inject(DOCUMENT) private dom: Document) {}

  setStructuredDataScript(data: object) {
    const id = 'ldata';
    const existingScript = this.dom.getElementById(id);
    if (existingScript) {
      existingScript.remove();
    }

    const script = this.dom.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    this.dom.head.appendChild(script);
  }

  removeStructuredDataScript() {
    const existingScript = this.dom.getElementById('ldata');
    if (existingScript) {
      existingScript.remove();
    }
  }

  createCanonicalLink(url: string) {
    this.removeCanonicalLink();

    const link: HTMLLinkElement = this.dom.createElement('link');

    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    this.dom.head.appendChild(link);
  }

  removeCanonicalLink() {
    const el = this.dom.querySelector("[rel='canonical']");
    if (el) {
      el.remove();
    }
  }

  preloadCoverImage(url: string): void {
    const existing = this.dom.querySelector(`link[rel="preload"][href="${url}"]`);
    if (existing) return;

    const linkEl = this.dom.createElement('link');
    linkEl.setAttribute('rel', 'preload');
    linkEl.setAttribute('as', 'image');
    linkEl.setAttribute('href', url);
    linkEl.setAttribute('type', 'image/webp');

    this.dom.head.appendChild(linkEl);
    // console.log('preloadCoverImage linkEl', linkEl);
  }
}
